<mat-form-field [appearance]="appearance">
    <mat-label>{{ label }}</mat-label>
    <mat-select (selectionChange)="onSelect($event.value)" [compareWith]="compareCategoryObjects" [disabled]="disabled"
                [value]="value">
        @for (time of times; track time) {
            <mat-option [value]="time">
                {{ time }}
            </mat-option>
        }
    </mat-select>
    <button class="h-fit-content p0" mat-icon-button
            matSuffix type="button">
        <mat-icon>access_time</mat-icon>
    </button>
</mat-form-field>
